"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

require("./Search.css");

var _Colors = _interopRequireDefault(require("../../Basic/Colors/Colors"));

require("../../Typography/Paragraph/Paragraph.css");

var _excluded = ["onChange", "onChangeInput", "onEnter", "id", "placeholder", "defaultValue", "className", "minCharacters", "hideIcon"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var searchIcon = ["url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' %3E%3Cpath d='M9.70711 16.7071C10.0976 16.3166 10.0976 15.6834 9.70711 15.2929C9.31658 14.9024 8.68342 14.9024 8.29289 15.2929L4.29289 19.2929C3.90237 19.6834 3.90237 20.3166 4.29289 20.7071C4.68342 21.0976 5.31658 21.0976 5.70711 20.7071L9.70711 16.7071Z' fill='%23091E42'/%3E%3Cpath d='M13 16C10.2386 16 8 13.7614 8 11C8 8.23858 10.2386 6 13 6C15.7614 6 18 8.23858 18 11C18 13.7614 15.7614 16 13 16ZM13 18C16.866 18 20 14.866 20 11C20 7.13401 16.866 4 13 4C9.13401 4 6 7.13401 6 11C6 14.866 9.13401 18 13 18Z' fill='%23091E42'/%3E%3C/svg%3E\")"];
var useStyles = (0, _styles.makeStyles)({
  root: {
    color: _Colors.default.vagaVesi,
    background: _Colors.default.hall4,
    minWidth: '222px',
    borderRadius: '5px',
    padding: '8px 16px',
    border: 'none',
    outline: 0,
    display: 'inline-block'
  },
  searchIcon: {
    paddingLeft: '48px',
    backgroundImage: searchIcon,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '8px center'
  }
});
/**
 * @visibleName Search
 */

function Search(_ref) {
  var onChange = _ref.onChange,
      onChangeInput = _ref.onChangeInput,
      onEnter = _ref.onEnter,
      id = _ref.id,
      placeholder = _ref.placeholder,
      defaultValue = _ref.defaultValue,
      className = _ref.className,
      minCharacters = _ref.minCharacters,
      hideIcon = _ref.hideIcon,
      rest = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles();

  var handleKeyUp = function handleKeyUp(event) {
    event.preventDefault();
    var val = event.target.value;

    if (onEnter && (!minCharacters || (val === null || val === void 0 ? void 0 : val.length) >= minCharacters) && event.key === 'Enter') {
      onEnter(val);
      return;
    }

    if (!minCharacters && event.key === 'Enter' || !!minCharacters && !!val && val.length >= minCharacters) {
      onChange(val);
    }
  };

  var handleChange = function handleChange(event) {
    return onChangeInput && onChangeInput(event.target.value);
  };

  var searchIconClass = !hideIcon ? classes.searchIcon : '';
  return /*#__PURE__*/_react.default.createElement("input", _extends({
    type: "search",
    id: id,
    name: id,
    className: classes.root.concat(" paragraph css-14 ".concat(searchIconClass, " ").concat(className)),
    onKeyUp: handleKeyUp,
    placeholder: placeholder,
    defaultValue: defaultValue,
    onChange: handleChange
  }, rest));
}

Search.propTypes = {
  /** Gets called when the user makes input with enough characters to search */
  onChange: _propTypes.default.func,

  /** Gets called when the user makes input */
  onChangeInput: _propTypes.default.func,

  /** Gets called when the user clicks enter */
  onEnter: _propTypes.default.func,

  /** Id and name of input element */
  id: _propTypes.default.string,

  /** Placeholder */
  placeholder: _propTypes.default.string,

  /** Default value */
  defaultValue: _propTypes.default.string,

  /** Min characters to activate search */
  minCharacters: _propTypes.default.number,

  /** Hide search icon */
  hideIcon: _propTypes.default.bool
};
Search.defaultProps = {
  placeholder: 'Search...'
};
var _default = Search;
exports.default = _default;